import styled from 'styled-components'
import { rem } from 'polished'
import { FormattedMessage, useIntl } from 'react-intl'
import LayoutContainer from 'components/Common/LayoutContainer'
import { mediaQueryUp } from 'components/utils/breakpoint'
import useIsAvailableForPurchase from '../hooks/useIsAvailableForPurchase'
import { NavWrapper } from 'components/OfferPage/styles'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import DesktopRelatedTravelItems from 'components/OfferPage/RelatedTravelItems'
import config from 'constants/config'
import clsx from 'clsx'
const Container = styled(NavWrapper)`
  flex: 1;

  &.hideOnMobile.hideOnMobile {
    display: none;
    ${mediaQueryUp.tablet} {
      display: flex;
      visibility: visible;
    }
  }
`
const Root = styled(LayoutContainer)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;

  ${mediaQueryUp.tablet} {
    margin-inline-start: auto;
  }

  > * + * {
    margin-inline-start: ${rem(12)};
  }

`

const MobileNewLine = styled.br`
  ${mediaQueryUp.tablet} {
    display: none;
  }
`

const InlineWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  & > * + * {
    margin-inline-start: ${rem(8)};
  }

  ${mediaQueryUp.tablet} {
    justify-content: flex-end;
  }
`

interface Props {
  offer: App.HotelOffer
  headlessMode: boolean
}

function LastMinuteOfferPageStickyFooter(props: Props) {
  const {
    offer,
    headlessMode,
  } = props

  const intl = useIntl()
  const availableForPurchase = useIsAvailableForPurchase()

  const displaySoldOutLabel = !availableForPurchase && !config.LERE_EXPIRED_DEALS_V2_ENABLED
  const hideSoldOutOnMobile = !availableForPurchase && config.LERE_EXPIRED_DEALS_V2_ENABLED

  const browseAllOffersLabel = intl.formatMessage({
    id: '9tJX6yaUGqtGS1U0xGJP',
    defaultMessage: 'Browse all offers',
    description: 'Button text to browse all available offers when current offer is sold out',
  })

  return (
    <Container className={clsx({ hideOnMobile: hideSoldOutOnMobile })}>
      <Root>
        {!headlessMode && <DesktopRelatedTravelItems offer={offer} />}
        {displaySoldOutLabel &&
          <InlineWrapper>
            <BodyText variant="medium" weight="bold" colour="normal-contrast">
              <FormattedMessage
                id="xZWgloxXg28B3GhXfBJT"
                defaultMessage="This offer has{br} SOLD OUT"
                description="Sold out label for last minute offer page sticky header"
                values={{
                  br: <MobileNewLine />,
                }}
              />
            </BodyText>
            <TextButton kind="primary" to="/">
              {browseAllOffersLabel}
            </TextButton>
          </InlineWrapper>}
      </Root>
    </Container>
  )
}

export default withOfferPageAndReduxState((state, appState) => ({
  headlessMode: appState.system.headlessMode,
}), LastMinuteOfferPageStickyFooter)
